import { MenuItem } from './menu.types';

export enum MenuItemName {
  foo = 'foo',
  calist = 'calist',
  cryptotokenlist = 'cryptotokenlist',
  profilelist = 'profilelist',
  provisionOperationalCa = 'provisionOperationalCa',
}

export interface MenuParams {
  isDebug: boolean;
  isEditor: boolean;
}

function isDebug(params: MenuParams): boolean {
  return params.isDebug;
}

function isEditor(params: MenuParams): boolean {
  return params.isEditor;
}

export const MenuConfig: MenuItem<MenuParams, MenuItemName>[] = [
  {
    name: MenuItemName.calist,
  },
  {
    name: MenuItemName.profilelist,
  },
  {
    name: MenuItemName.cryptotokenlist,
  },
  {
    name: MenuItemName.foo,
    showIf: isDebug,
  },
  {
    name: MenuItemName.provisionOperationalCa,
    showIf: isEditor,
  },
];

// Example config with two levels and restrictions of visibility
//
// export interface MenuParams {
//   isAdmin: boolean;
// }
//
// function isAdmin(params: MenuParams): boolean {
//   return params.isAdmin;
// }
//
// export const MenuConfig: MenuItem<MenuParams, MenuItemName>[] = [
//   {
//     name: MenuItemName.foo,
//     children: [
//       {
//         name: MenuItemName.fooChild1,
//       },
//       {
//         name: MenuItemName.fooChild2,
//       },
//       {
//         name: MenuItemName.fooChildAdmin,
//         showIf: isAdmin,
//       },
//     ],
//   },
//   {
//     name: MenuItemName.adminMenu,
//     showIf: isAdmin,
//   },
//   {
//     name: MenuItemName.baz,
//   },
//   {
//     name: MenuItemName.bar,
//     children: [
//       {
//         name: MenuItemName.barChild1,
//       },
//       {
//         name: MenuItemName.barChild2,
//       },
//       {
//         name: MenuItemName.barChild3,
//       },
//     ],
//   },
// ];
